import React, {useEffect, useState} from 'react';
import style from './style.scss'
import newId from '../../utils/newid';
import Label from './Label';


const RenderText = (props) => {
    const {item, field, validateField,isReadOnly,type="text"} = props;
    const id = newId();
    const [error, setError] = useState(false);
    const [value, setValue] = useState((typeof field !== "undefined") && field[item.item]);


    let timer = false;
    const hasError = field.error && field.error[item.item]&&true;
    return (
        <div className={style.typeText+" "+(hasError?style.hasError:'')}>
            {
                (typeof item.label !== 'undefined') &&
                <Label
                    id={id}
                    parentClass
                    label={item.label}
                />}
            {error && 'error'}

            <input
                type={type}
                id={id}
                className={style.input + " " + error && style.hasError}
                // value={(typeof field !== "undefined") && field[item.item]}
                
                value={value ? value : (( type === 'number')? '' :'')}

                onChange={(t) => {
                    setValue(t.target.value);
                    return props.handleChange(t.target.value)

                }}
                min={item.min}
                readOnly={isReadOnly}
            />
            {item.label && item.label.second && <span className={style.secondLabel}>{item.label.second}</span>}
            {hasError &&
            <span className={style.errorMessage}>{field.error[item.item]}</span>}
        </div>
    )
}

export default RenderText;
